var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkeletonTopProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 938,
    height: 147,
    fill: "none",
    viewBox: "0 0 938 147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 118.222,
    height: 101.333,
    fill: "#F5F5F8",
    rx: 5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 90.074,
    height: 11.259,
    y: 135.52,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 56.296,
    height: 11.259,
    y: 113,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 118.222,
    height: 101.333,
    x: 332,
    fill: "#F5F5F8",
    rx: 5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 90.074,
    height: 11.259,
    x: 332,
    y: 135.52,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 56.296,
    height: 11.259,
    x: 332,
    y: 113,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 118.222,
    height: 101.333,
    x: 653,
    fill: "#F5F5F8",
    rx: 5
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 90.074,
    height: 11.259,
    x: 653,
    y: 135.52,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 56.296,
    height: 11.259,
    x: 653,
    y: 113,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 118.222,
    height: 101.333,
    x: 166,
    fill: "#F5F5F8",
    rx: 5
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 90.074,
    height: 11.259,
    x: 166,
    y: 135.52,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 56.296,
    height: 11.259,
    x: 166,
    y: 113,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 118.222,
    height: 101.333,
    x: 498,
    fill: "#F5F5F8",
    rx: 5
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 90.074,
    height: 11.259,
    x: 498,
    y: 135.52,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 56.296,
    height: 11.259,
    x: 498,
    y: 113,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 118.222,
    height: 101.333,
    x: 819,
    fill: "#F5F5F8",
    rx: 5
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 90.074,
    height: 11.259,
    x: 819,
    y: 135.52,
    fill: "#F5F5F8",
    rx: 5.63
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 56.296,
    height: 11.259,
    x: 819,
    y: 113,
    fill: "#F5F5F8",
    rx: 5.63
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkeletonTopProducts);
export default __webpack_public_path__ + "static/media/skeleton-top-products.570e7348.svg";
export { ForwardRef as ReactComponent };